import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useMedplum, useMedplumProfile } from "@medplum/react";

// resourceType will never return "admin",
// but it is a role so we can use the isAllowed
// to return true only on the isProjectAdmin() check
type Role = "Admin" | "Practitioner" | "Patient";

interface ProtectedRoutesProps {
  children: React.ReactNode;
  allowedRoles: Role[];
  routes: string[];
}

export default function Protected({ children, allowedRoles, routes }: ProtectedRoutesProps) {
  const navigate = useNavigate();
  const profile = useMedplumProfile();
  const location = useLocation();
  const medplum = useMedplum();
  const isAllowed =
    allowedRoles.includes(profile?.resourceType as Role) || medplum.isProjectAdmin();

  useEffect(() => {
    if (routes.some((route) => location.pathname.includes(route)) && !isAllowed) {
      navigate(`/clients`);
    }
  }, [routes, location.pathname, isAllowed, navigate]);

  return <>{children}</>;
}
